<div style="position: relative;">
    <mat-icon class="tool-icon" title="除錯輔助工具" [appOpenDialog]="tool">
        build
    </mat-icon>
</div>



<app-vis-dialog title="系統輔助工具" (close)="tool.show=false" #tool [width]="600" [height]="500">
    <div class="controlled-font-size-large" style="padding: 5px;">
        <div style="margin: 5px 0px;">
            <div>檢驗測試</div>
            <div class="tool-items">
                <button (click)="CreateFakeResult()">產生今日檢驗報告到檢驗平台</button>
                <button >產生成人健檢報告</button>
            </div>
            <div class="tool-items">
                <input placeholder="集團代碼" style="width: 50px;flex-grow: 1;" [(ngModel)]="companyCode">
                <input placeholder="醫事機構代碼" style="width: 100px;flex-grow: 1;" [(ngModel)]="clinicNhiCode">
                <input type="text" maxlength="20" placeholder="身分證字號" aria-label="身分證字號" style="width: 120px;flex-grow: 1;" [(ngModel)]="labPatientCId">
                <app-vis-datepicker [(ngModel)]="labImportSt"></app-vis-datepicker>
                ~
                <app-vis-datepicker [(ngModel)]="labImportEd"></app-vis-datepicker>
                <button (click)="importLabFrom()">匯入</button>
            </div>
            <!-- <button (click)="TestITreat()">測試就醫識別馬</button> -->
        </div>

        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative">
            <div>CSHIS 6.0：</div>
            <div class="tool-items">

                <button (click)="CSHIS6Open()">啟動</button>
                <button (click)="CSHIS6Init()">初始化</button>
                <button (click)="CSHIS6Console()">設定</button>
                <button (click)="CSHIS6Close()">關閉</button>
            </div>
        </div>
        <div >
            <div>API測試：</div>
            <div class="tool-items">

                <a style="font-size: 14px;" class="mr-2 position-relative azure cursor-pointer"
                    (click)="cnhieiiTest($event)">
                    <mat-icon class="mat-icon position-absolute vis-combine-icon">storage</mat-icon>
                    <div class="text-lg d-inline-flex" style="text-indent: 24px;">醫療資料傳輸共同介面</div>
                </a>
                <a style="font-size: 14px;" class="position-relative orange cursor-pointer"
                    (click)="dayliUploadTest($event)">
                    <mat-icon class="mat-icon position-absolute vis-combine-icon">upload_for_offline</mat-icon>
                    <div class="text-lg d-inline-flex" style="text-indent: 22px;">每日上傳</div>
                </a>
                <a style="font-size: 14px;" class="position-relative orange cursor-pointer"
                    (click)="referalDownloadTest($event)">
                    <mat-icon class="mat-icon position-absolute vis-combine-icon">upload_for_offline</mat-icon>
                    <div class="text-lg d-inline-flex" style="text-indent: 22px;">轉診單開立</div>
                </a>

                    <mat-checkbox [checked]="useWebApi" (change)="useWebApiChecked($event)">就醫識別碼使用WebApi</mat-checkbox>
                    <!-- <button (click)="getTreat()">取得就醫識別碼</button>
                        {{tNum}} -->

            </div>
            <div class="tool-items">
                <button (click)="isPolarisDialogOpened = true">北極星掛號查詢</button>
            </div>
            <div class="tool-items">
                <button (click)="isLineBotDialogOpened = true">LineBot 診間資料查詢</button>
            </div>

        </div>
        <div style="margin: 5px 0px;">
            <div>就醫識別碼模擬器：</div>
            <div class="tool-items">
                <input style="width: 80px;flex-grow: 1;" placeholder="機構碼(6)" [(ngModel)]="treat_hinno">
                <input style="width: 100px;flex-grow: 1;" placeholder="身分證(10)" [(ngModel)]="treat_cid">
                <app-vis-datepicker placeholder="就診日期時間(yyyMMddHHmmss)" [(ngModel)]="treat_dt"></app-vis-datepicker>
                <app-vis-timepicker [showSecond]="true" [(ngModel)]="treat_tm"></app-vis-timepicker>
                <button (click)="TestITreat()">產生</button>
            </div>
            <div class="tool-items">
                結果：<input style="width: 200px;flex-grow: 1;" [(ngModel)]="treat_no">(如有雷同純屬巧合)
                <button (click)="ParseTreat()">解析</button>
                <button (click)="ClearTreat()">清除</button>
            </div>
            <!-- <button (click)="TestITreat()">測試就醫識別馬</button> -->
        </div>
        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative">
          <div>政府公開資料：</div>
          <div class="tool-items">
              <button (click)="ImportCalendarOpen()">匯入政府辦公日曆</button>
          </div>
        </div>
        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative">
            <div>線上使用者查詢：</div>
            <div class="tool-items">
                <button [appOpenDialog]="onlineUsers" >檢視</button>
            </div>
        </div>
        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative">
            <div>資料匯出匯入工具</div>
            <div class="tool-items">
                <button [appOpenDialog]="openDatePull" >匯出</button>
                <button [appOpenDialog]="openDatePush" >匯入</button>
            </div>
        </div>

        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative">
          <div>系統設定 匯出匯入工具</div>
          <div class="tool-items">
            <button [appOpenDialog]="openSystemSetting" (click)="systemSettingType = 'export'; isOpenSystemSetting = true">匯出</button>
            <button [appOpenDialog]="openSystemSetting" (click)="systemSettingType = 'import'; isOpenSystemSetting = true">匯入</button>
          </div>
        </div>

        <app-vis-dialog title="資料匯出工具" [width]="1200" [height]="500" #openDatePull>
          <div style="display: flex; align-items: center;column-gap: 10px;">
            <mat-checkbox [(ngModel)]="Rx">醫令</mat-checkbox>
            <mat-checkbox [(ngModel)]="MainSet">套餐</mat-checkbox>
            <mat-checkbox [(ngModel)]="CC">主訴</mat-checkbox>
            <mat-checkbox [(ngModel)]="Dosage">頻率</mat-checkbox>
            <button (click)="onBtnQueryPullClick()">搜尋</button>
          </div>
          <div *ngIf="showBtnGroup">
            <mat-button-toggle-group [(ngModel)]="WhichTableShow">
              <mat-button-toggle [value]="0" (click)="pageReset()" *ngIf="Rx" >醫令</mat-button-toggle>
              <mat-button-toggle [value]="1" (click)="pageReset()" *ngIf="MainSet">套餐</mat-button-toggle>
              <mat-button-toggle [value]="2" (click)="pageReset()" *ngIf="CC">主訴</mat-button-toggle>
              <mat-button-toggle [value]="3" (click)="pageReset()" *ngIf="Dosage">頻率</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div *ngIf="WhichTableShow === 0">
            <app-vis-grid [data]="RxData" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="pageChange($event)" [selectable]="true">
              <app-vis-grid-column field="RxCode" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="ProdName" title="名稱" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="StdCode" title="健保碼" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <div *ngIf="WhichTableShow === 1">
            <app-vis-grid [data]="ShowExportMainSet" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="pageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Code" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="DxApplyCode" title="診斷" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="RxSetList" title="醫令" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <div *ngIf="WhichTableShow === 2">
            <app-vis-grid [data]="CCData" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="pageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Code" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="Name" title="內容" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <div *ngIf="WhichTableShow === 3">
            <app-vis-grid [data]="DosageData" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="pageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Code" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="Name" title="名稱" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="ApplyCode" title="申報代碼" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="TMDay" title="天" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="TMQty" title="次" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <button *ngIf="showBtnGroup" (click)="onBtnExportClick()">確認匯出</button>
        </app-vis-dialog>



        <app-vis-dialog title="資料匯入工具" [width]="1200" [height]="500" #openDatePush>
          <input type="file" id="fileInput" accept=".json,application/json" />
          <button (click)="onBtnImportfileClick()">確認</button>
          <div *ngIf="showImportBtnGroup">
            <mat-button-toggle-group [(ngModel)]="WhichImporTableShow">
              <mat-button-toggle [value]="0" (click)="ImportpageReset()" *ngIf="Rx" >醫令</mat-button-toggle>
              <mat-button-toggle [value]="1" (click)="ImportpageReset()" *ngIf="MainSet">套餐</mat-button-toggle>
              <mat-button-toggle [value]="2" (click)="ImportpageReset()" *ngIf="CC">主訴</mat-button-toggle>
              <mat-button-toggle [value]="3" (click)="ImportpageReset()" *ngIf="Dosage">頻率</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div *ngIf="WhichImporTableShow === 0">
            <app-vis-grid [data]="ImportRxDataView" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="ImportpageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Change" title="狀態" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="RxCode" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="ProdName" title="名稱" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="StdCode" title="健保碼" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="IsAlive" title="是否存活" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <div *ngIf="WhichImporTableShow === 1">
            <app-vis-grid [data]="ImportMainSetDataView" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="ImportpageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Change" title="狀態" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="Code" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="DxApplyCode" title="診斷" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="RxSetList" title="醫令" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <div *ngIf="WhichImporTableShow === 2">
            <app-vis-grid [data]="ImportCCDataView" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="ImportpageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Code" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="Name" title="內容" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <div *ngIf="WhichImporTableShow === 3">
            <app-vis-grid [data]="ImportDosageDataView" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo"
              [pageable]="true" (pageChange)="ImportpageChange($event)" [selectable]="true">
              <app-vis-grid-column field="Code" title="代碼" [width]="100" i18n-title="@@Code"></app-vis-grid-column>
              <app-vis-grid-column field="Name" title="名稱" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="ApplyCode" title="申報代碼" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="TMDay" title="天" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
              <app-vis-grid-column field="TMQty" title="次" i18n-title="@@Name" class="custom-name"></app-vis-grid-column>
            </app-vis-grid>
          </div>
          <button *ngIf="showImportBtnGroup" (click)="onBtnImportAPIClick()">確認匯入</button>
        </app-vis-dialog>

        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative">
            <div>科學中藥工具</div>
            <div class="tool-items">
                <button [appOpenDialog]="openChiMedEndateEditor" >設定停用藥</button>
                <button (click)="confirmService.showAlert('還沒好','想用嗎? 自己寫啊~')" >修正複方成分</button>
            </div>
        </div>

        <div style="width: 100%;text-align: start;;vertical-align: middle;" class="position-relative" *ngIf="false">
            <div>測試工具：</div>
            <div class="tool-items">
                <button (click)="openPoker()" >發牌</button>
                <button (click)="randCard()" >洗牌</button>
                <button (click)="openMine()" >雷</button>
                <button (click)="openGomoku()" >五</button>
                <button (click)="openSnack()" >蛇</button>
                <button (click)="tokenTest()" >測試token</button>
            </div>
        </div>
    </div>


</app-vis-dialog>
<ng-container *ngIf="tool.show">
    <app-mine #mine></app-mine>
    <app-poker-desk #poker></app-poker-desk>
    <app-gomoku #gomoku></app-gomoku>   
    <app-snack #snack></app-snack>
</ng-container>
<app-vis-dialog [title]="'QRCode掃描器'" [width]="300" (close)="qrcode.show=false" #qrcode>
    <app-qrcode-scanner *ngIf="qrcode.show" (onSuccess)="onQRCodeScanResult($event,qrcode)"></app-qrcode-scanner>
</app-vis-dialog>


<app-vis-dialog title="匯入政府辦公日曆" [height]="200" [width]="400" [show]="isImportCalendarOpened" (close)="isImportCalendarOpened = false">
  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
    <div>
      <span i18n="@@CalendarRocYear">現在民國年：</span>
      <input type="number" class="vis-input" [(ngModel)]="nowRocYear" min="112" max="199" maxlength="3" disabled/>
    </div>
    <div>
      <span i18n="@@CalendarRocYear">選擇民國年：</span>
      <input type="number" class="vis-input" [(ngModel)]="importCalendarRocYear" min="112" max="199" maxlength="3" required (change)="CalendarRocYearChange()"/>
    </div>
    <div>
      <span i18n="@@CalendarCount">{{calendarCountHint}}</span>
    </div>
  </div>
  <app-vis-dialog-actions>
    <button type="button" (click)="ImportCalendar()" i18n="@@DialogConfirm">確定</button>
    <button type="button" (click)="isImportCalendarOpened = false" i18n="@@DialogClose">取消</button>
  </app-vis-dialog-actions>
</app-vis-dialog>

<app-vis-dialog title="線上使用者" [width]="1200" [height]="600" #onlineUsers>
    <div style="display: flex;justify-content: end;align-items: center;column-gap: 10px;">
        <app-vis-button (click)="BroadcaseNotify()" [label]="'廣播'" [icon]="'send'"></app-vis-button>
        <mat-checkbox [(ngModel)]="showAllUser">顯示全部使用者</mat-checkbox>
        <mat-checkbox [(ngModel)]="hide7day">只顯示7日內使用者</mat-checkbox>
        <app-vis-button (click)="reloadCurrentUser()" [label]="'重新整理'" [icon]="'refresh'"></app-vis-button>
    </div>
    <!--
  UserId:number;
  ComputerName,
                x.ConsoleConnected
  ConnectionId:string;-->
    <app-vis-grid [data]="users" [showStickyHead]="true" [showStickyTableRows]="10">
        <app-vis-grid-column [field]="'CompanyCode'" [title]="'集團碼'" [width]="60"></app-vis-grid-column>
        <app-vis-grid-column [field]="'ClinicCode'" [title]="'診所碼'" [width]="60" ></app-vis-grid-column>
        <app-vis-grid-column [field]="'ClinicName'" [title]="'診所名稱'" [width]="120"></app-vis-grid-column>
        <app-vis-grid-column [field]="'ComputerName'" [title]="'電腦名'" [width]="160">
            <ng-template let-data>
                <div>
                    <div>
                        {{data.UserName}}
                    </div>
                    <button style="height: 25px;width: 100%;justify-content: center;" *ngIf="data.ComputerName" (click)="getConsoleInfo(data)">
                        <mat-icon>search</mat-icon>
                        {{data.ComputerName}}
                    </button>
                </div>
                
            </ng-template>
        </app-vis-grid-column>
        <!-- <app-vis-grid-column [field]="'State'" [title]="'狀態'" [width]="80"></app-vis-grid-column> -->
        <app-vis-grid-column [field]="'ConsoleConnected'" [title]="'控'" [width]="20">
            <ng-template let-data>
                <div style="width: 15px;height: 15px;border-radius: 10px;"
                    [ngStyle]="{backgroundColor:data.ConsoleConnected?'limeGreen':'red'}">
                </div>
            </ng-template>
        </app-vis-grid-column>
        <app-vis-grid-column [field]="'StartDatetime'" [dateTimeFormat]="'DateTime'" [title]="'登入時間'" [width]="180">
            <ng-template let-data>
                <div *ngIf="data.IP">
                    <div> {{data.IP}} </div>
                    <div>{{data.LastAlifeDatetime|formatROCFullDateTime:'/':':'}} </div>
                </div>
                <div *ngIf="!data.IP">離線</div>
            </ng-template>
        </app-vis-grid-column>
        <app-vis-grid-column [field]="'LastAlifeDatetime'" [dateTimeFormat]="'DateTime'" [title]="'最後活動時間'" [width]="180">
            <ng-template let-data>
                <div *ngIf="data.IP" [ngStyle]="recentOnlineStyle(data)">
                    {{data.LastAlifeDatetime|formatROCFullDateTime:'/':':'}}
                </div>
                <div *ngIf="!data.IP">離線</div>
            </ng-template>
        </app-vis-grid-column>
        <app-vis-grid-column [field]="'License'" [title]="'授權'" [width]="130">
            <ng-template let-data>
                <ng-container *ngIf="data.LicenseKey">
                    <span >✔️</span>
                    <button (click)="releaseLicense(data)">釋出裝置</button>
                </ng-container>
                
            </ng-template>
        </app-vis-grid-column>
        <app-vis-grid-column [title]="'指令'">
            <ng-template let-data>
                <button (click)="uploadLog(data)">上傳log</button>
                <button (click)="update(data)">主控更新</button>
                <button (click)="getLogs(data)">下載log</button>
                <button (click)="notifyUser(data)">通知</button>
                <!-- <button (click)="logout(data)">登出</button>
                <button (click)="refresh(data)">重整</button> -->

            </ng-template>
        </app-vis-grid-column>
    </app-vis-grid>
</app-vis-dialog>

<app-vis-dialog title="下載Log" [width]="400" [height]="400" [show]="showLogList" (close)="showLogList=false" #logList>
    <app-search-bar>
        <input searchBarField="檔名" #fNameKey>
        <app-vis-button [icon]="'search'" [label]="'過濾'" (click)="filterLog(fNameKey.value)"></app-vis-button>
    </app-search-bar>

    <app-vis-grid [data]="logFilesFiltered" [showStickyHead]="true" [showStickyTableRows]="10">

        <app-vis-grid-column [field]="'name'" [title]="'檔名'" [width]="200" ></app-vis-grid-column>
        <app-vis-grid-column [field]="'path'" [title]="'下載'" [width]="120">
            <ng-template let-data>
                <button style="height: 25px;width: 50%;justify-content: center;" (click)="download(data.path)">
                    <mat-icon>download</mat-icon>下載
                </button>
                <button *ngIf="canView(data.path)" style="height: 25px;width: 50%;justify-content: center;" (click)="view(data.path)">
                    <mat-icon>search</mat-icon>檢視
                </button>
            </ng-template>
        </app-vis-grid-column>

    </app-vis-grid>
</app-vis-dialog>
<app-vis-dialog title="Log檢視" [width]="1200" [height]="600" [show]="showLogDetail" (close)="showLogDetail=false" >
    <app-search-bar [formGroup]="logDetailFh.FormGroup">
        <app-vis-timepicker style="width: 150px;" searchBarField="時間(起)" formControlName="stime"></app-vis-timepicker>
        <app-vis-timepicker style="width: 150px;" searchBarField="時間(迄)" formControlName="etime"></app-vis-timepicker>
        <input searchBarField="關鍵字"  formControlName="keyword">
        <app-vis-button [icon]="'search'" [label]="'過濾'" (click)="filterLogDetail()"></app-vis-button>
    </app-search-bar>

    <app-vis-grid [data]="logDetailsFiltered" [showStickyHead]="true" [showStickyTableRows]="10">
        <app-vis-grid-column [field]="'date'" [title]="'日期'" [width]="110"></app-vis-grid-column>
        <app-vis-grid-column [field]="'time'" [title]="'時間'" [width]="120"></app-vis-grid-column>
        <app-vis-grid-column [field]="'type'" [title]="'類型'" [width]="60"></app-vis-grid-column>
        <app-vis-grid-column [field]="'st'" [title]="'狀態'" [width]="60"></app-vis-grid-column>
        <app-vis-grid-column [field]="'msg'" [title]="'訊息'"></app-vis-grid-column>
        <app-vis-grid-column [title]="'詳細'" [width]="60">
            <ng-template let-data>
                <button *ngIf="data.msg.startsWith('Websocket recieve user message')" style="height: 25px;width: 100%;justify-content: center;" (click)="viewDetailMsg(data.msg)">
                    <mat-icon>search</mat-icon>詳細
                </button>
            </ng-template>
        </app-vis-grid-column>

    </app-vis-grid>
</app-vis-dialog>
<app-vis-dialog title="主控台資訊" [width]="1000" [height]="650" [show]="showConsoleInfo" (close)="showConsoleInfo=false">
    <div style="display: flex;flex-wrap: wrap;">
        <div style="width: 100%;display: flex;margin: 5px 20px;">
            <div style="width: 100px;">電腦名稱(IP)：</div>
            <div style="flex-grow: 1;">{{consoleInfo?.ComputerName}}({{consoleInfo?.IP}})</div>
        </div>
        <div style="width: 250px;display: flex;margin: 5px 20px;">
            <div style="width: 100px;">最後紀錄時間：</div>
            <div style="flex-grow: 1;">{{consoleInfo?.DateTime}}</div>
        </div>
        <div style="width: 150px;display: flex;margin: 5px 20px">
            <div style="width: 100px;">主控台版本：</div>
            <div style="flex-grow: 1;">{{consoleInfo?.Version}}</div>
        </div>
        <div style="display: flex;margin: 5px 20px;flex-grow: 1;text-align: right;">
            <div style="flex-grow: 1;">{{consoleInfo?.NetworkState}}</div>
        </div>
    </div>

    <hr style="margin: 0px;">
    
    <div style="display: flex;width: calc(100% - 40px);">
        <div style="width: 25%;">
            <div style="display: flex;margin: 5px 20px">
                <div style="width: 100px;">模組：</div>
            </div>
            <table style="margin: 5px 20px 5px 20px;">
                <tr *ngFor="let item of consoleInfo?.Mods">
                    <td style="width: 150px;padding-left: 10px;">{{item.Name}}</td>
                    <td style="text-align: center;">{{item.Ver}}</td>
                </tr>
            </table>
        </div>
        <div style="width: 75%"> 
            <div style="display: flex;margin: 5px 0px">
                <div style="width: 100px;">健保主控台：</div>
            </div>
            <app-search-bar [Cols]="4">
                <div [searchBarField]="'SAM卡'">{{consoleInfo?.SAMInstalled?'✅':'❌'}}</div>
                <div [hidden]="!consoleInfo?.CSHIS" [searchBarField]="'讀卡機類型'" class="text-primary">{{consoleInfo?.CSHIS?.READER==0?'晶片':'健保'}}讀卡機</div>
                
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('COMX','COM編號','COM')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('快速認證','醫師卡快速認證','MSGSHOW')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('燈號視窗','是否顯示燈號視窗','CSWATCH')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('SAM自動認證','是否自動 SAM 認證','CSAUTOVSAM')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('顯示主控台','是否顯示雲端安全模組主控台','CSFSIM')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('HCA','是否啟用 HCA DLL','HCA')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('顯示訊息','卡片變更時是否顯示訊息','MSGSHOW')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('逾時秒數','逾時秒數','CSTIMEOUT')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('離線認證','是否啟用離線認證','CSOFFAUTH')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('遠端模式','是否啟用遠端模式','CSREMOTE')}"></ng-container>
                <ng-container *ngTemplateOutlet="col;context:{$implicit:displayData('保留HIS','結束主控台時是否保留 HIS 程式','CLSCSFSIM')}"></ng-container>

                <ng-template let-data #col>
                    <div [hidden]="!consoleInfo?.CSHIS" [searchBarField]="data.label" 
                    [ngClass]="data.cls">{{data.value}}</div>
                </ng-template>

                
                
                
            </app-search-bar>
            
        </div>
    </div>
    
    <hr style="margin: 0px;">
    <ng-container *ngIf="consoleInfo">
        <div  style="display: flex;">
            <div style="width: 50%;">
                <div style="display: flex;margin: 5px 20px;">
                    <div style="width: 100px;">暫存路徑：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.TempPath}}</div>
                </div>
                <div style="display: flex;margin: 5px 20px;">
                    <div style="width: 100px;">Log路徑：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.LogPath}}</div>
                </div>
                <div style="display: flex;margin: 5px 20px;">
                    <div style="width: 100px;">pdf報表位置：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.DirectPDFPrintFolder}}</div>
                </div>
                <div style="display: flex;margin: 5px 20px;">
                    <div style="width: 100px;">檔案儲存位置：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.FileSavePath}}</div>
                </div>
            </div>
            <div style="width: 50%;display: flex;flex-wrap: wrap;">
                <div style="display: flex;margin: 5px 0px;width: 50%;">
                    <div style="width: 120px;">開機啟動：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.StartOnBoot}}</div>
                </div>
                <div style="display: flex;margin: 5px 0px;width: 50%;">
                    <div style="width: 120px;">Log保留月數：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.LogMaintainMonth}}</div>
                </div>
                <div style="display: flex;margin: 5px 0px;width: 50%;">
                    <div style="width: 120px;">ws port：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.WsServerPort}}</div>
                </div>
                <div style="display: flex;margin: 5px 0px;width: 50%;">
                    <div style="width: 120px;">直接pdf輸出：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.DirectPDFPrint}}</div>
                </div>
                <div style="display: flex;margin: 5px 0px;width: 50%;">
                    <div style="width: 120px;">使用預設印表機：</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.UseDefaultPrinter}}</div>
                </div>
                <div style="display: flex;margin: 5px 0px;width: 50%;">
                    <div style="width: 120px;">debug模式</div>
                    <div style="flex-grow: 1;">{{consoleInfo?.Config.DebugMode}}</div>
                </div>
            </div>
        </div>

        <app-vis-grid  [data]="consoleInfo?.Config.Printers" [showStickyHead]="true" [showStickyTableRows]="5">
            <app-vis-grid-column [field]="'ReportName'" [title]="'報表名'" [width]="120"></app-vis-grid-column>
            <app-vis-grid-column [field]="'ReportType'" [title]="'代號'" [width]="80" ></app-vis-grid-column>
            <app-vis-grid-column [field]="'PrinterName'" [title]="'印表機'"></app-vis-grid-column>
            <app-vis-grid-column [field]="'PaperSize'" [title]="'紙張'" [width]="120"></app-vis-grid-column>
        </app-vis-grid>
        <hr style="margin: 5px;">
        <mat-button-toggle-group>
            <mat-button-toggle *ngFor="let item of keys(consoleInfo.Printers)" [value]="item" (click)="switchPrinter(item)">{{item}}</mat-button-toggle>
        </mat-button-toggle-group>
        <app-vis-grid  [data]="paperSizeGrid" [showStickyHead]="true" [showStickyTableRows]="5">
            <app-vis-grid-column [field]="'PaperName'" [title]="'紙張'" [width]="300"></app-vis-grid-column>
            <app-vis-grid-column [field]="'Width'" [title]="'寬'" [width]="100" ></app-vis-grid-column>
            <app-vis-grid-column [field]="'Height'" [title]="'高'" [width]="100"></app-vis-grid-column>
        </app-vis-grid>
    </ng-container>
</app-vis-dialog>

<app-vis-dialog [width]="600" [height]="600" title="新增科中停用日期" #openChiMedEndateEditor>
    <app-chi-med-expire-tool (close)="openChiMedEndateEditor.close()"></app-chi-med-expire-tool>
</app-vis-dialog>

<app-vis-dialog [width]="1200" [height]="650" title="系統設定 匯出匯入工具" #openSystemSetting >
  <app-system-setting-export-import *ngIf="isOpenSystemSetting" (close)="openSystemSetting.close(); isOpenSystemSetting = true" [settingType]="systemSettingType"></app-system-setting-export-import>
</app-vis-dialog>

<app-vis-dialog title="北極星掛號查詢 API 測試" [width]="620" [height]="420"
  [show]="isPolarisDialogOpened" (close)="isPolarisDialogOpened = false">
  <div style="padding: 8px; display: flex; flex-direction: column; gap: 6px;">
    <div>
      <span style="display: inline-block; width: 130px;">API 位址</span>
      <input class="vis-input" style="width: 400px;" [(ngModel)]="polarisBaseUrl">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">X-DEV 金鑰</span>
      <input class="vis-input" style="width: 400px;" [(ngModel)]="polarisKey">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">ddate</span>
      <input class="vis-input" style="width: 150px;" placeholder="yyyy-MM-dd" [(ngModel)]="polarisDdate">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">from_time</span>
      <input class="vis-input" style="width: 150px;" placeholder="HH:mm:ss" [(ngModel)]="polarisFromTime">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">to_time</span>
      <input class="vis-input" style="width: 150px;" placeholder="HH:mm:ss" [(ngModel)]="polarisToTime">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">mode</span>
      <select class="vis-input" style="width: 150px;" [(ngModel)]="polarisMode">
        <option value="incremental">incremental</option>
        <option value="full">full</option>
      </select>
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">cursor</span>
      <input class="vis-input" style="width: 400px;" placeholder="有下一頁時自動填入，清空即從第一頁重查"
        [(ngModel)]="polarisCursor">
    </div>
    <div style="margin-top: 4px;">{{ polarisResultHint }}</div>
  </div>
  <app-vis-dialog-actions>
    <button type="button" (click)="testPolarisRegister()">送出</button>
    <button type="button" (click)="polarisCursor = ''">清除 cursor</button>
    <button type="button" (click)="isPolarisDialogOpened = false">關閉</button>
  </app-vis-dialog-actions>
</app-vis-dialog>

<app-vis-dialog title="LineBot 診間資料查詢 API 測試" [width]="620" [height]="360"
  [show]="isLineBotDialogOpened" (close)="isLineBotDialogOpened = false">
  <div style="padding: 8px; display: flex; flex-direction: column; gap: 6px;">
    <div>
      <span style="display: inline-block; width: 130px;">API 位址</span>
      <input class="vis-input" style="width: 400px;" [(ngModel)]="lineBotBaseUrl">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">X-DEV 金鑰</span>
      <input class="vis-input" style="width: 400px;" [(ngModel)]="lineBotKey">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">病歷號</span>
      <input class="vis-input" style="width: 150px;" [(ngModel)]="lineBotPatientNo">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">身分證</span>
      <input class="vis-input" style="width: 150px;" [(ngModel)]="lineBotCId">
    </div>
    <div>
      <span style="display: inline-block; width: 130px;">Count</span>
      <input class="vis-input" style="width: 150px;" placeholder="留空即不帶，後端預設 3" [(ngModel)]="lineBotCount">
    </div>
    <div style="margin-top: 4px;">{{ lineBotResultHint }}</div>
  </div>
  <app-vis-dialog-actions>
    <button type="button" (click)="testLineBotRecord()">送出</button>
    <button type="button" (click)="isLineBotDialogOpened = false">關閉</button>
  </app-vis-dialog-actions>
</app-vis-dialog>
